import { i18n } from '@/plugins/i18n'

export const releasingType = {
    ALL: 1,
    BASED_ON_BALANCE: 2,
};

export const releasingTypeStr = {
    ALL: i18n.t('releasing_type.all'),
    BASED_ON_BALANCE: i18n.t('releasing_type.based_on_balance'),

    get(type) {
        let type_str = null;

        Object.keys(releasingType).forEach(item => {
            if(releasingType[item] === type) {
                type_str = releasingTypeStr[item];
            }
        });

        return type_str;
    }
};
